type BusinessScopeUser = {
  isB2B: boolean;
  businessName?: string;
};

export function hasEssentialDemoScope(user: BusinessScopeUser | null | undefined) {
  const normalizedBusinessName = user?.businessName
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/gi, '')
    .toLocaleLowerCase('es-MX');

  return Boolean(
    user?.isB2B
    && normalizedBusinessName === 'mcmultifoods',
  );
}
